import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "15",
  viewBox: "0 0 16 15",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M10.0298 9.31693C9.78576 9.561 9.39001 9.561 9.14595 9.31693L7.27095 7.44193C7.15376 7.32475 7.08789 7.16575 7.08789 7V3.875C7.08789 3.52982 7.3677 3.25 7.71289 3.25C8.05808 3.25 8.33789 3.52982 8.33789 3.875V6.74112L10.0298 8.43306C10.2739 8.67712 10.2739 9.07287 10.0298 9.31693Z" }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M0.462891 7.5C0.462891 3.35786 3.82075 -1.81059e-07 7.96289 0C12.105 1.81058e-07 15.4629 3.35786 15.4629 7.5C15.4629 11.6421 12.105 15 7.96289 15C3.82075 15 0.462891 11.6421 0.462891 7.5ZM7.96289 1.25C4.51111 1.25 1.71289 4.04822 1.71289 7.5C1.71289 10.9517 4.51111 13.75 7.96289 13.75C11.4146 13.75 14.2129 10.9517 14.2129 7.5C14.2129 4.04822 11.4146 1.25 7.96289 1.25Z"
    }, null, -1)
  ])))
}
export default { render: render }